import PropTypes from 'prop-types';
import React from 'react';
import styles from './Breadcrumb.module.css';

const Breadcrumb = ({ items, onTrocarLoja, temMultiplasLojas = false, nomeLojaAtiva = '' }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className={styles.breadcrumb}>
      <div className={styles.items}>
        {items.map((item, index) => (
          <React.Fragment key={`${item.label}-${index}`}>
            {index > 0 && <span className={styles.separator}>/</span>}
            <span className={styles.current}>{item.label}</span>
          </React.Fragment>
        ))}
      </div>
      {temMultiplasLojas && onTrocarLoja && (
        <div className={styles.lojaActions}>
          {nomeLojaAtiva && (
            <span className={styles.nomeLojaAtiva} title={nomeLojaAtiva}>
              {nomeLojaAtiva}
            </span>
          )}
          <button className={styles.trocarLojaBtn} onClick={onTrocarLoja}>
            Trocar Loja
          </button>
        </div>
      )}
    </div>
  );
};

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  onTrocarLoja: PropTypes.func,
  temMultiplasLojas: PropTypes.bool,
  nomeLojaAtiva: PropTypes.string,
};

export default Breadcrumb;
